const MajorMinor = {
  BOTH: "BOTH",
  MAJOR: "MAJOR",
  MINOR: "MINOR",
};

const MajorMinorEntity = {
  [MajorMinor.BOTH]: {
    value: MajorMinor.BOTH,
    groupingValue: "BOTH",
    label: "Both",
  },
  [MajorMinor.MAJOR]: {
    value: MajorMinor.MAJOR,
    groupingValue: "MAJOR",
    label: "Major",
  },
  [MajorMinor.MINOR]: {
    value: MajorMinor.MINOR,
    groupingValue: "MINOR",
    label: "Minor",
  },
};

export default MajorMinor;
export { MajorMinorEntity };
